import defaultStyle from './styles/DirectButtonLink.scss';

const DirectButtonLink = ({ text, href, showArrow, className, style = defaultStyle }) => {
	const classes = style['direct-button-link'] +
		(className ? ` ${className}` : '')
	;

	return (
		<a className={classes} href={href}>{text}{showArrow ? <span className={style.arrow} /> : null}</a>
	);
};

export default DirectButtonLink;


// WEBPACK FOOTER //
// ./components/button/DirectButtonLink.js